import { supabase } from '../lib/supabase';
import type { RadarProfile, SchoolOption } from '../types/app';

export async function loadAvailableSchools(profile: RadarProfile): Promise<SchoolOption[]> {
  if (!supabase) return [];

  let query = supabase
    .from('schools')
    .select('id,name,short_name,active')
    .eq('active', true)
    .order('name');

  if (profile.role !== 'admin') {
    if (!profile.school_id) return [];
    query = query.eq('id', profile.school_id);
  }

  const { data, error } = await query;
  if (error) throw error;
  return (data || []) as SchoolOption[];
}
